import axios from "../axios/axios";
import {
  ConsultRfzoRequestBody,
  ConsultRfzoTherapyResponse,
} from "../types/consultRfzo.types";

// ITAM-2887 advisor RFZO service. The ENTIRE surface is raising the empty
// request: the pharmacy fills it in, and the advisor never orders it.
//
// Meaningful errors are 400: the duplicate ({errorCode, message} JSON) and the
// identifier rules (a bare plain-text sentence). See mapRfzoRequestError.

/** POST /rfzo_therapy -> 201 + the REQUESTED therapy (no items, no price). */
export const createRfzoTherapyRequest = (
  body: ConsultRfzoRequestBody,
  signal?: AbortSignal,
): Promise<ConsultRfzoTherapyResponse> => {
  return axios
    .post<ConsultRfzoTherapyResponse>("/rfzo_therapy", body, { signal })
    .then((res) => res.data);
};
